import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../../../shared-components/TextField/TextField';
import { isEmpty } from '../../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';

//Copying current pattern matching textinput uses in CAPE
export const isValidPostalCode = (msg) => (value) => {
    const pattern = /^[0-9]{5}(-)?([0-9]{4})?$/;

    if (pattern.test(value)){
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class ZipCode extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;

        return (
            <Field
                id="postalCode"
                name="postalCode"
                autoComplete="disabled"
                autoCorrect="off"
                autoCapitalize="off"
                component={TextField}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.postalCode-label`})}
                maxLength="10"
                validate={[
                    isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-empty`})),
                    isValidPostalCode(intl.formatMessage({id: `${LOCALE_PREFIX}.billinginfo-zip-invalid`}))
                ]}
            />
        );
    }
}

export default injectIntl(ZipCode);
